import { render } from "./editVisit.vue?vue&type=template&id=5776f68b"
import script from "./editVisit.vue?vue&type=script&lang=js"
export * from "./editVisit.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__